<form class="flex flex-column gap-3 p-fluid" (ngSubmit)="changePassword()">
  <input pInputText
         name="currentPassword"
         type="password"
         autocomplete="current-password"
         required
         [placeholder]="translations.profileSettings.changePassword.insertOldPassword | translate"
         [(ngModel)]="currentPassword">

  <input pInputText
         name="newPassword"
         type="password"
         autocomplete="new-password"
         required
         [placeholder]="translations.profileSettings.changePassword.insertNewPassword | translate"
         [(ngModel)]="newPassword">

  <input pInputText
         name="repeatNewPassword"
         type="password"
         autocomplete="new-password"
         required
         [placeholder]="translations.profileSettings.changePassword.repeatNewPassword | translate"
         [(ngModel)]="repeatNewPassword">

  <div class="flex justify-content-between mt-2">
    <button pButton
            pRipple
            type="button"
            class="p-button-outlined p-button-secondary"
            [disabled]="loading"
            [label]="translations.commons.cancel | translate"
            (click)="close()"></button>
    <button pButton
            pRipple
            type="submit"
            class="p-button-success"
            [loading]="loading"
            [label]="translations.commons.save | translate"></button>
  </div>
</form>
